var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9826 11C13.7459 11 15.9855 8.76133 15.9855 6C15.9855 3.23867 13.7459 1 10.9826 1C8.21929 1 5.97971 3.23867 5.97971 6C5.97971 8.76133 8.21929 11 10.9826 11ZM10.9826 2.25C13.0518 2.25 14.7348 3.93203 14.7348 6C14.7348 8.06758 13.0518 9.75 10.9826 9.75C8.91344 9.75 7.23043 8.06641 7.23043 6C7.23043 3.93203 8.915 2.25 10.9826 2.25ZM12.9642 12.875H9.00099C5.26094 12.875 2.22754 15.9062 2.22754 19.6445C2.22754 20.3922 2.83414 20.9988 3.58223 20.9988H18.3838C19.1319 21 19.7377 20.3945 19.7377 19.6445C19.7377 15.9062 16.7047 12.875 12.9642 12.875ZM18.3814 19.75H3.58223C3.52517 19.75 3.47826 19.7031 3.47826 19.6445C3.47826 16.6016 5.95626 14.125 9.00099 14.125H12.9603C16.009 14.125 18.4869 16.6016 18.4869 19.6445C18.4869 19.7031 18.44 19.75 18.3814 19.75Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.947d5a33b7c5481d331535889bda0534.svg";
export { ForwardRef as ReactComponent };